(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("slideout"));
	else if(typeof define === 'function' && define.amd)
		define("vue-slideout", ["slideout"], factory);
	else if(typeof exports === 'object')
		exports["vue-slideout"] = factory(require("slideout"));
	else
		root["vue-slideout"] = factory(root["slideout"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition